module.exports = __webpack_public_path__ + "assets/media/lunch.fc87961a.mp3";